import React from "react";
import congrats from "../assets/images/congrats.svg";
import "../styles/feedback.css";

export const ThankYouPage = () => {
  return (
    <div className="feedback-page-container">
      <>
        <div className="feedback-content">
          <div
            className="mx-auto order-confirm no-bg "
            style={{ marginTop: "9rem !important" }}
          >
            <div className="row d-flex">
              <div className="w-100 d-flex justify-content-center mt-4 position-relative">
                <img
                  src={congrats}
                  alt="Congrats"
                  className="img-fluid congrats-img"
                />
              </div>

              <div className="text-center px-3">
                <div className="thankyou-title">Thanks for submitting!</div>
              </div>
            </div>
          </div>
        </div>
      </>
    </div>
  );
};
